export default __webpack_public_path__ + "static/media/read-more.d9bc6cab.svg";